import { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";
import { Spinner } from "../../atoms/Spinner";

export interface PaginatedListLoadingProps {
  className?: string;
  /** Replaces the default translated "Loading..." message. */
  message?: ReactNode;
}

export const PaginatedListLoading = ({ className, message }: PaginatedListLoadingProps) => {
  const { t } = useTranslation();

  return (
    <div data-slot="paginated-list-loading" className={cn("flex flex-1 items-center justify-center p-6", className)}>
      <Spinner size="sm" color="muted">
        {message ?? t("Loading...")}
      </Spinner>
    </div>
  );
};
